/**
 * Retrieval API service.
 * See docs/api/retrieval-ask-contract.md for the full contract.
 */
import { axiosInstance } from './api';

const BASE = '/retrieval';

/**
 * Ask a question and receive composed results.
 * @param {string} question
 * @param {boolean} [skipCompose=false] - Skip LLM composition for faster results
 * @returns {Promise<Object>} The ask response per contract
 */
export const askQuestion = async (question, skipCompose = false) => {
  const body = { question };
  if (skipCompose) body.skip_compose = true;
  const response = await axiosInstance.post(`${BASE}/ask/`, body);
  return response.data;
};

/**
 * Get suggestion chips for the current family.
 * @returns {Promise<string[]>}
 */
export const getSuggestionChips = async () => {
  try {
    const response = await axiosInstance.get(`${BASE}/suggestions/`);
    return response.data.chips || [];
  } catch {
    return [];
  }
};

/**
 * Get search history for the current user.
 * @param {string} [personId] - filter by person
 * @param {number} [limit=20]
 * @returns {Promise<{entries: Array, nextCursor: string|null}>}
 */
export const getSearchHistory = async (personId, limit = 20) => {
  const params = new URLSearchParams({ limit: String(limit) });
  if (personId) params.set('person_id', personId);
  const response = await axiosInstance.get(`${BASE}/search-history/?${params}`);
  return response.data;
};
